export const CUSTOM_UNINSTALL = 'eo_custom_event-UNINSTALL';

export const CUSTOM_DATASOURCES = {
  [CUSTOM_UNINSTALL]: 'UNINSTALL (custom)',
};
